/**
 * StatsPills - Status filter pills for the Overview page
 *
 * Displays clickable stat cards for filtering photos by status.
 */

// Status pill configuration with colors and labels
// Order: Total, Done, Review, Tagging, Problems, Skipped (left-to-right, action pills first)
const PILL_CONFIG = [
  { key: null, label: "Total", getValue: (t) => t.total, color: "#66ffb7" },
  { key: "done", label: "Done", getValue: (t) => t.doneTotal, color: "#66ffb7" },
  { key: "review", label: "Review", getValue: (t) => t.review || 0, color: "#66d9e8" },
  { key: "tagging", label: "Tagging", getValue: (t) => t.tagging || 0, color: "#ff9b64" },
  { key: "problems", label: "Problems", getValue: (t) => (t.attention || 0) + (t.error || 0), color: "#ff6b6b" },
  { key: "skipped", label: "Skipped", getValue: (t) => t.skipped || 0, color: "#888888" },
];

// Pipeline status cards (non-clickable, with progress stripes)
// Simplified: detecting/identifying collapsed into "processing" on backend
const PIPELINE_PILLS = [
  { key: "processing", label: "Processing", stageKey: "pipeline" },
  { key: "ingested", label: "Ingested", stageKey: "merovingian" },
];

function StatsPills({ totals, activeFilters, onToggle, onClear, metrics }) {
  const handleCardKey = (handler) => (e) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      handler();
    }
  };

  const renderStripe = (stageKey, label, activeCount) => {
    if (activeFilters.length) return null;
    if (!activeCount) return null;
    // Pulsing indicator to show activity (static key prevents animation restart)
    return (
      <div
        className="card-fill card-fill-pulse"
        key={stageKey}
        aria-label={`${label} in progress`}
      />
    );
  };

  return (
    <div className="stat-grid">
      {/* Clickable filter pills */}
      {PILL_CONFIG.map((pill) => {
        const isActive = pill.key === null
          ? activeFilters.length === 0
          : activeFilters.includes(pill.key);
        const onClick = pill.key === null ? onClear : () => onToggle(pill.key);

        return (
          <div
            key={pill.key || "total"}
            className={`stat-card ${isActive ? "active" : ""}`}
            role="button"
            tabIndex={0}
            onClick={onClick}
            onKeyDown={handleCardKey(onClick)}
            style={{ "--stat-color": pill.color, cursor: "pointer" }}
          >
            <div className="label">{pill.label}</div>
            <div className="value">{pill.getValue(totals)}</div>
          </div>
        );
      })}

      {/* Pipeline status pills (non-clickable, with progress stripes) */}
      {PIPELINE_PILLS.map((pill) => (
        <div key={pill.key} className="stat-card">
          <div className="label">{pill.label}</div>
          <div className="value">{totals[pill.key] || 0}</div>
          {renderStripe(pill.stageKey, pill.label, totals[pill.key])}
        </div>
      ))}
    </div>
  );
}

export default StatsPills;
